import { featureFlags } from "$global-providers/feature-flags-provider/feature-flags";
import { useFeatureFlag } from "$global-providers/feature-flags-provider/provider";
import { TabContentOnline } from "$routes/patient/[:patientId]/_lib/invoices/TabContentOnline";
import { TabContentRxdb } from "$routes/patient/[:patientId]/_lib/invoices/TabContentRxdb";
import { TabContentV2 } from "$routes/patient/[:patientId]/_lib/invoices-v2/tab-content-v2";

export const TabContent: FC<{ patientId: string }> = ({ patientId }) => {
  const [rxdbBillingFlag] = useFeatureFlag<boolean>(
    featureFlags.billing.rxdbBilling,
  );
  const [rxdbPriceListFlag] = useFeatureFlag<boolean>(
    featureFlags.billing.priceListRxdb,
  );

  if (rxdbBillingFlag) {
    return <TabContentV2 patientId={patientId} />;
  }

  return rxdbPriceListFlag ? (
    <TabContentRxdb patientId={patientId} />
  ) : (
    <TabContentOnline patientId={patientId} />
  );
};
